<script setup>
/**
 * The picture at the top of a policy: its line's own icon on its own colour,
 * the same pair the staff record draws, so changing either on Policy lines
 * changes every card.
 */
import { computed } from 'vue';
import PolicyLineIcon from '../policyLines/PolicyLineIcon.vue';

const props = defineProps({
  line: { type: Object, default: null },
  height: { type: Number, default: 118 },
  iconSize: { type: Number, default: 54 },
});

// No line at all: a neutral shield rather than somebody else's colour.
const color = computed(() => props.line?.color || '#867D8D');
const style = computed(() => ({
  height: `${props.height}px`,
  background: `linear-gradient(150deg, ${color.value}14, ${color.value}26)`,
}));
</script>

<template>
  <div class="cov-art" :style="style" data-testid="policy-art" aria-hidden="true">
    <span class="cov-art__icon" :style="{ color }">
      <PolicyLineIcon :name="line?.icon || 'shield'" :size="iconSize" />
    </span>
  </div>
</template>

<style scoped>
.cov-art { position: relative; display: grid; place-items: center; overflow: hidden; }
.cov-art__icon { opacity: 0.8; display: grid; }
</style>
